<template>
    <div id="rmalist"  :style="{maxWidth:screenWidth}">
        <el-card>
            <el-row :gutter="20">
                <el-col :span="4">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
                        <el-breadcrumb-item>RMA LIST</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>


                <el-col :span="16" style="float: right;">
                    <el-row :gutter="5">
                        <el-col :span="8">
                            <el-select  v-model="queryInfo.status" placeholder="choose status" multiple collapse-tags >
                                <el-option label="All" value='10'> </el-option>
                                <el-option label="RMA Reported" value='0'> </el-option>
                                <el-option label="Sunwave Response" value='1'> </el-option>
                                <el-option label="Return to Sunwave" value='2'> </el-option>
                                <el-option label="Analysis&Repair" value='3'> </el-option>
                                <el-option label="Return to Customer" value='4'> </el-option>
                            </el-select>
                        </el-col>

                        <el-col :span="8">
                            <el-select  v-model="queryInfo.column" placeholder="Item being searched">
                                <el-option label="Faulty Category" value='faulty_category'> </el-option>
                                <el-option label="Fault Description" value='faulty_description'> </el-option>
                                <el-option label="Servicing Record" value='servicing_record'> </el-option>
                                <el-option label="Corrective Action" value='corrective_action'> </el-option>
                                <el-option label="Don't choose any" value=''> </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="8">
                            <el-input placeholder="Enter search keywords" v-model="queryInfo.query">
                                <el-button slot="append" icon="el-icon-search" @click="seacher"></el-button>
                            </el-input>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="4"  >

                    <el-button v-if="role==='3'" type="primary" @click="showAdd()" style="float: right;">Add RMA</el-button>
                </el-col>
            </el-row>
        </el-card>

        <el-table

                border=""
                :data="tasklist"
                style="width: 100%"
        >
            <el-table-column
                    prop="create_time"
                    label="RMA Submit Date">
            </el-table-column>
            <el-table-column
                    prop="close_date"
                    label="RMA Closed Date">
            </el-table-column>
            <el-table-column
                    prop="rma_number"
                    label="RMA Number">
            </el-table-column>
            <el-table-column
                    prop="company"
                    label="Company">
            </el-table-column>

            <el-table-column
                    width="300px"
                    prop="status"
                    :formatter="formatBoolean"
                    label="RMA Status">
            </el-table-column>

            <el-table-column
                    label="Options">
                <template slot-scope="scope">
                    <el-row :gutter="20">

                        <el-col v-if="role!=='3'" :span="4">
                            <i class="el-icon-delete" title="Delete" @click="deleteit(scope.row.id)"></i>
                        </el-col>
                        <el-col :span="4">
                            <i class="el-icon-edit" title="Edit" @click="reply(scope.row.id)"></i>
                        </el-col>
                        <el-col :span="4" >
                            <i class="el-icon-close" v-if="role!=='3'" title="Close" @click="Close(scope.row.id)"></i>
                        </el-col>
                    </el-row>
                </template>

            </el-table-column>
        </el-table>

        <el-card>
            <el-row :gutter="20">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryInfo.pagenum"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="queryInfo.pagesize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </el-row>
        </el-card>
        <el-dialog
                title="编辑"
                :visible.sync="editVisible" @click="addClose">
            <el-form :model="editForm" :rules="rules" ref="editFormRef">

                <el-form-item prop="id" label="id" hidden>
                    <el-input v-model="editForm.id" ></el-input>
                </el-form-item>
                <el-form-item prop="email" label="邮箱">
                    <el-input v-model="editForm.email" ></el-input>
                </el-form-item>

                <el-form-item prop="phone" label="电话">
                    <el-input v-model="editForm.phone" ></el-input>
                </el-form-item>
                <el-form-item prop="name" label="昵称">
                    <el-input v-model="editForm.name" ></el-input>
                </el-form-item>

                <el-form-item v-if="role==='1'" prop="role" label="修改用户类型" >
                    <el-radio-group v-model="editForm.role">
                        <el-radio :label="2">管理员</el-radio>
                        <el-radio :label="3">普通用户</el-radio>
                    </el-radio-group>
                </el-form-item>



            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="edit">submit</el-button>
            </span>
        </el-dialog>

        <el-card>
            <el-row :gutter="20">
                <el-col :span="8" v-for="(itmp,index) in doclist">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <h4>{{doclistTile[index]}} <i class="el-icon-view" @click="clickit(itmp)"></i> </h4>
                        </el-col>
                        <el-col :span="24">
                            <el-upload
                                    :headers="myHeaders"
                                    class="upload-demo"
                                    :action="geturl(itmp)"
                                    :on-preview="handlePreview"
                                    :on-remove="( file, fileList)=>handleRemove( file, fileList,itmp)"
                                    :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,itmp)"
                                    :before-remove="beforeRemove"
                                    multiple
                                    accept=".pdf"
                                    :limit="1"
                                    :on-exceed="handleExceed"
                                    :file-list="doc[itmp]">

                                <el-button title="upload" v-if="role!='3'" size="small" type="primary"><i class="el-icon-upload2"></i></el-button>

                            </el-upload>
                            <el-button title="download" class="download" size="small"   @click="downloaddocs(itmp)"><i class="el-icon-download"></i></el-button>

                            <el-button title="view" class="download" size="small"   @click="clickit(itmp)"><i class="el-icon-view"></i></el-button>
                        </el-col>
                    </el-row>



                </el-col>

            </el-row>
        </el-card>

            <el-dialog
                    style="padding-bottom: 20px"
                    v-for="(itmp,index) in doclist"
                    :title=itmp
                    :visible.sync= doclistview[itmp]
                    width="70%"
                    >

                    <pdf
                            v-for="i in 20"
                            :src=" $http.defaults.baseURL2 + 'upload/doc/' + itmp + '.pdf'"
                            :page="i"
                    ></pdf>

            </el-dialog>


    </div>
</template>

<script>

    import pdf from "vue-pdf";
    var token =  localStorage.getItem('token')
    export default {
        components: {
            pdf
        },
        name: "UserList.vue",
        data(){
            return{
                policy:false,
                process:false,
                requirements:false,
                screenWidth: document.body.clientWidth-310 + "px",
                myHeaders: {token: token},
                queryInfo:{
                    status:[],
                    column:"",
                    query:"",
                    page:1,
                    close:"",
                    pagesize:10,
                },
                doclistview:{policy:false,process:false,requirements:false},
                doclistpage:{policy:true,process:true,requirements:true},
                doclistcount:{policy:0,process:0,requirements:0},
                doclist:["policy","process","requirements"],
                doclistTile:["Instruction of RMA policy","Instruction of RMA process","return requirements"],
                doc:{},
                total:0,
                tasklist:[],
                addVisible:false,
                editVisible:false,
                isdowning:false,

                addForm:{},
                editForm:{},
                temp:"",
                role:"",
                depss:{},
                rules:{

                },

            }

        },

        created() {
            document.title = "RMA LIST - Welcome to Sunwave’s RMA Process System";

            this.getTaskList();
            this.getDoc();
        },
        methods:{

            async getTaskList(){

                this.queryInfo.close=this.$route.params.close;

                console.log(this.queryInfo.close);
                const result=await this.$http.post("rma/list",{params:this.queryInfo});
                if(result.data.error_code!==0){
                    this.$message.error(result.data.msg);
                }else {
                    this.tasklist=result.data.data.data;
                    this.total=result.data.data.total;
                    this.queryInfo.pagesize=parseInt(result.data.data.per_page);
                    this.queryInfo.page=result.data.data.current_page;

                }
                this.role=localStorage.getItem("role");

            },
            async getDoc(){
                const result=await this.$http.get("doc/info");
                if(result.data.error_code!==0){
                    this.$message.error(result.data.msg);
                }else {
                    this.doc=result.data.data;

                }
            },
            seacher(){
                this.queryInfo.page=1;
                this.getTaskList();
            },
            handleSizeChange(newSize){
                this.queryInfo.pagesize=newSize;
                this.getTaskList();
            },
            addClose(){
                this.$refs.addFormRef.resetFields();
                this.editVisible=false;
            },
            handleCurrentChange(newPage){
                this.queryInfo.page=newPage;
                this.getTaskList();
            },
            async showAdd(){
                this.$router.push('/rma/add','_blank');
            },

            async reply(id){
                this.$router.push('/rma/edit/'+id);
            },
            async Close(id){
                const result=await this.$http.get("rma/close/"+ id);
                if(result.data.error_code!==0){
                    this.$message.error(result.data.msg);
                }else {
                   this.getTaskList();

                }
            },

            async getDate(id){
                const result=await this.$http.get("rma/info/"+id);
                this.editForm=result.data.data;
            }
            ,
            geturl(itmp){
                return this.$http.defaults.baseURL + "doc/upload/" + itmp
            },
            clickit(itmp){
                this.doclistview[itmp]=true;
            },
            edit() {
                this.$refs.editFormRef.validate(async valid => {
                    if (!valid) {
                        console.log('error submit!!');
                        return false;
                    }
                    const result=await this.$http.post("rma/edit",this.editForm);
                    if (result.data.error_code!==0){
                        this.$message.error(result.data.msg);
                    }else {
                        this.$message.success(result.data.msg);
                        this.editVisible=false;
                        this.getTaskList();
                    }
                });
            },
            async status(id){
                const result=await this.$http.get("rma/status/"+id);

                if (result.data.error_code!==0){
                    this.$message.error(result.data.msg);
                }else {
                    this.$message.success(result.data.msg);
                    this.getTaskList();
                }
            },
            async deleteit(id){
                const result=await this.$http.get("rma/delete/"+id);
                if (result.data.error_code!==0){
                    this.$message.error(result.data.msg);
                }else {
                    this.$message.success(result.data.msg);
                    this.getTaskList();
                }
            },

            async handleRemove(file, fileList,type) {
                await this.$http.get("doc/del/"+ type);

            },

            handleSuccess(response, file, fileList,type){
                this.doc[type]=[{name: response.data, url: response.data}];
            },
            handlePreview(file) {
                console.log(file);
            },
            handleExceed(files, fileList) {
                this.$message.warning(`Limit to select 1 files, this time selected ${files.length} Files, selected ${files.length + fileList.length} files selected`);
            },
            beforeRemove(file, fileList) {
                if(this.role==='3'){
                    this.$message.error("No permission");
                    return false;
                }
                return this.$confirm(`remove ${ file.name }？`);
            },

            async downloaddocs(type){
                this.isdowning=true;
                const res=await this.$http.get("file/download2/" + type,{responseType: 'blob'});
                const content = res.data
                console.log(content);
                const blob = new Blob([content],{type:"application/pdf"})
                // var timestamp = (new Date()).valueOf();
                const fileName = type+'.pdf'
                if ('download' in document.createElement('a')) { // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = window.URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    window.URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                } else { // IE10+下载
                    navigator.msSaveBlob(blob, fileName)
                }

                this.isdowning=false;
            },
            formatBoolean: function (row, column) {
                if(row.status === 0){
                    return 'RMA Reported'
                }
                if(row.status === 1){
                    return 'Sunwave Response'
                }
                if(row.status === 2){
                    return 'Return to Sunwave'
                }
                if(row.status === 3){
                    return 'Analysis&Repair'
                }

                if(row.status === 4){
                    return 'Return to Customer'
                }

                if(row.status === 9){
                    return 'closed'
                }
            },


        },
        watch:{
            "queryInfo.status":function (newval,oldval) {
                let difference = newval.concat(oldval).filter(v => !newval.includes(v) || !oldval.includes(v))
                if(difference[0] === "10"){
                    if(newval.indexOf("10") >= 0){
                        this.queryInfo.status=["0","1","2","3","4"]
                    }else {
                        this.queryInfo.status=[]
                    }
                }
                this.getTaskList();
            },

            "queryInfo.column":function (newval,oldval) {
                this.getTaskList();
            },
            $route(to,from){
                if(this.$route.params.close){
                    this.getTaskList();
                }
            }
        }
    }
</script>

<style lang="less">
    #rmalist{
        .el-table{

        }
        .el-breadcrumb{
            padding-top: 10px;
        }
        .el-card{
            margin-bottom: 5px;
        }
        .el-table{
            margin-bottom: 5px;
        }
        .el-table-column{
            padding-left: 10px;
        }
        .el-form{
            width: 100%;
        }

        .upload-demo{
            float: left;
            width: 60%;
        }
        .download{
            width: 15%;
            float: left;
        }

        .el-upload{
            float: left;
            width: 20%;
        }


        .el-upload-list{
            width: 80%;
            float: left;
            ul{
                padding: 0;
            }
            li{
                padding: 0;
                margin: 0;
            }
        }
        .el-pagination span{
            font-size: 14px;
            line-height: 35px;
        }
        .el-pagination .el-select .el-input{
            margin-top: -5px;
        }
        .el-pagination button.btn-prev,
        .el-pagination button.btn-next,
        .el-pagination ul.el-pager{
            margin-top: 5px;
        }

    }

</style>
